import { AlertContext } from '../components/LegacyAlert/LegacyAlert';
import { ExtendedAlertMessage } from '~/components/LegacyAlert/LegacyAlert';
import { Variant } from 'react-bootstrap/esm/types';
import { useContext } from 'react';

interface AlertFunction {
  /**
   * Pop up the message to the user.
   *
   * @param message - The alert message. Can be a string or an object with `message`, `error`, and `link` properties.
   * @param variant - One of `primary, secondary, success, danger, warning, info, dark, light`.
   * @param autoDismiss - If false, forces the user to dismiss the alert. Defaults to true.
   * @param seconds - (Optional) Time in seconds after which the alert auto-dismisses. If omitted, uses the default timeout.
   */
  ( message: string | ExtendedAlertMessage, variant: Variant, autoDismiss?: boolean, seconds?: number ): void;
}

/**
 * @returns A function that can be used to display an alert.
 */
export const useAlert = (): AlertFunction =>
  useContext( AlertContext ).addAlert as (
    message: string | ExtendedAlertMessage,
    variant: Variant,
    autoDismiss?: boolean,
    seconds?: number,
  ) => void;
